import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { BaseEditService, BaseEditCreateService } from '../../../services';
import { SummaryItem } from '../../../models';
import { MockEditService } from '../../../mock';
import { BaseEditFormComponent } from '../../base-edit-form/base-edit-form.component';

@Component({
  selector: 'app-base-edit-form-modal',
  templateUrl: './base-edit-form-modal.component.html',
  styleUrl: './base-edit-form-modal.component.scss',
})
export class BaseEditFormModalComponent implements AfterContentChecked {
  @ViewChild(BaseEditFormComponent) form: BaseEditFormComponent;

  @Input() id: string;
  @Input() parentId: string;
  @Input() parentId2: string;
  @Input() alwaysSave = false;
  @Input() fields: FormlyFieldConfig[];
  @Input() header: string;
  @Input() showSave = true;
  @Input() summaryItems: (model: any) => SummaryItem[];
  @Input() baseService: BaseEditService<any, any> | BaseEditCreateService<any, any> = new MockEditService();
  @Input() model: any = {};
  @Output() modelUpdated = new EventEmitter<any>();
  @Output() saved = new EventEmitter<any>();

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  updateModel(model: any, markUpdated = true) {
    this.form.updateModel(model, markUpdated);
  }
}
